<template>
    <div>
        <form class="search" v-on:submit.prevent>
            <button>
                <img src="../../images/icons/search.svg" :alt="search_translation.title">
            </button>

            <label for="playerSearchInput" class="sr-only">{{ search_translation.title }}</label>
            <input
                id="playerSearchInput"
                type="search"
                :placeholder="search_translation.placeholder + '...'"
                autocomplete="off"
                v-on:keydown.enter="$event.stopPropagation()"
                v-model.trim="searchTerm"/>
        </form>

        <message-component v-if="showError" :status="errorStatus" :message="errorMessage"/>
        <message-component v-if="!searched" status="generic" :message="search_translation.message"/>

        <ul class="players">
            <player-list-item-component
                v-for="player in filteredPlayers"
                v-bind:player="player"
                v-bind:key="player.id"
                v-bind:player_base_route="player_base_route"/>
        </ul>

        <div :class="{'is-loading is-loading-dark': isLoading}"></div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Diacritics from 'diacritic';
    import PlayerListItemComponent from './PlayerListItemComponent.vue';

    export default {
        components: { PlayerListItemComponent },
        props: ['search', 'message_error', 'message_no_results', 'player_base_route', 'search_translation'],
        data() {
            return {
                players: [],
                searchTerm: this.search,
                showError: false,
                errorStatus: 'generic',
                errorMessage: '',
                searched: false,
                isLoading: true,
            }
        },
        computed: {
            filteredPlayers: function () {
                const search = Diacritics.clean(this.searchTerm.toLowerCase());
                const players = this.players.filter(function (player) {
                    return (player.search_name.toLowerCase().indexOf(search.toLowerCase()) !== -1);
                }).sort(function (a, b) {
                    if (a.first_name < b.first_name)
                        return -1;
                    if (a.first_name > b.first_name)
                        return 1;
                    return 0;
                }).slice(0, 10);
                if (players.length === 0) {
                    this.showError = true;
                    this.errorStatus = 'generic';
                    this.errorMessage = this.message_no_results;
                } else {
                    this.showError = false;
                }
                return players;
            }
        },
        mounted() {
            this.showError = false;
            this.$nextTick(function () {
                axios.get('/api/players').then((response) => {
                    this.isLoading = false;
                    this.players = response.data;
                }).catch(() => {
                    this.errorStatus = 'error';
                    this.errorMessage = this.message_error;
                    this.showError = true;
                });
            });
        },
        watch: {
            searchTerm: function(newValue, oldValue) {
                this.searched = true;
                this.searchTerm = newValue;
            }
        }
    }
</script>
